import { render, staticRenderFns } from "./TranslationFilters.vue?vue&type=template&id=293c15ef&scoped=true"
import script from "./TranslationFilters.vue?vue&type=script&lang=js"
export * from "./TranslationFilters.vue?vue&type=script&lang=js"
import style0 from "./TranslationFilters.vue?vue&type=style&index=0&id=293c15ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c15ef",
  null
  
)

export default component.exports